import { toTitleCase } from "../../../../Utils/stringUtls";

const CardPrinterOverview = ({ data }) => {
  const {
    of_cpfh_company_name,
    of_cpfh_name,
    of_cpfh_desk,
    of_cpfh_email,
    of_cpfh_card_manufacturer,
    of_cpfh_other_networks,
  } = data["6_3"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="fw-700 review-summary-sub-heading">
        <div i2c-grid="12@md">
          <div className="fw-700 font-bold">
            Card Printer / Fulfillment House
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Company</div>
          <div className="overview-val-text">
            {of_cpfh_company_name?.length
              ? toTitleCase(of_cpfh_company_name)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Name</div>
          <div className="overview-val-text">
            {of_cpfh_name?.length ? toTitleCase(of_cpfh_name) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Desk</div>
          <div className="overview-val-text">
            {of_cpfh_desk?.length ? toTitleCase(of_cpfh_desk) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {of_cpfh_email?.length ? of_cpfh_email : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Card Manufacturer – PCI compliant
          </div>
          <div className="overview-val-text">
            {of_cpfh_card_manufacturer?.length
              ? toTitleCase(of_cpfh_card_manufacturer)
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Other Networks/Vendor Integrations
          </div>
          <div className="overview-val-text">
            {of_cpfh_other_networks?.length
              ? toTitleCase(of_cpfh_other_networks)
              : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CardPrinterOverview;
